import {
  Box,
  CounterBadge,
  Divider,
  SidebarItemNext,
} from '@wix/design-system';
import { SettingsSmall } from '@wix/wix-ui-icons-common/lazy';
import React from 'react';
import { useTranslation } from '@wix/app-market-core';
import { RoutePath } from '@wix/app-market-core-types';
import { constantSidebarKeys } from '../sidebar-constants';

interface SidebarFooterProps {
  pendingAppsCount: number;
  onClick(): void;
}

export function SidebarFooter({
  pendingAppsCount,
  onClick,
}: SidebarFooterProps) {
  const { t } = useTranslation();

  return (
    <>
      <Divider direction="horizontal" />

      <SidebarItemNext
        itemKey={constantSidebarKeys[RoutePath.MANAGE_APPS]}
        onClick={onClick}
        dataHook="sidebar-footer.manage-apps"
        suffix={
          pendingAppsCount ? (
            <CounterBadge skin="danger">{pendingAppsCount}</CounterBadge>
          ) : null
        }
      >
        <Box verticalAlign="middle" gap="20px">
          <SettingsSmall />
          {t('sidebar.manage-apps')}
        </Box>
      </SidebarItemNext>
    </>
  );
}
